import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20golden%20amber%20abstract%20gradient%20background%20with%20soft%20organic%20shapes%2C%20elegant%20minimalist%20design%2C%20luxurious%20texture%2C%20subtle%20geometric%20patterns%2C%20warm%20inviting%20atmosphere%2C%20no%20text&width=1800&height=600&seq=cta-bg-91c&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-primary-900/80" />

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-background-50">
          准备好探索91c的全部价值了吗？
        </h2>
        <p className="mt-4 text-sm md:text-base text-background-100/70 max-w-lg mx-auto">
          立即开始使用91c，体验智能数据管理带来的效率提升。免费注册，无需信用卡。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/tutorials"
            className="px-8 py-3 bg-background-50 text-primary-700 rounded-full font-medium text-sm hover:bg-background-100 transition-all duration-300 whitespace-nowrap"
          >
            开始使用
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-background-50/40 text-background-50 rounded-full font-medium text-sm hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}